import { v4 } from "uuid";
import axiosInstance from "../../../http-common";
import {
  generateEditableColumns,
  generateStaticColumns,
  generateTestColumns,
} from "./reviewerGridColumns";
import { logout_if_403 } from "../../../util";

export const getErrorMessage = (error) => {
  if (error instanceof Error) return error.message;
  return String(error);
};

export const load_reviewer_data_from_backend = async (
  data,
  setData,
  category,
  setLoading
) => {
  // console.log(category);
  setLoading(true);
  try {
    const result = await axiosInstance.get(`v1/qc/reviewer_data/${category}`);
    // ?client_id=sunpharma_dewas_sterile_API
    if (result.data) {
      // const tableData = result?.data?.data?.map((item) => ({ ...item, id: v4() }));
      const tableData = result?.data?.data.map((item) => ({
        ...item,
        id: v4(),
      }));
      console.log(tableData);
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(tableData);
      }
    }
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
  } finally {
    setLoading(false);
  }
};

export const getReviewerHeaders = async () => {
  try {
    const result = await axiosInstance.get(`v1/qc/get_reviewer_headings`);
    // http://127.0.0.1:8000/v1/qc/get_reviewer_headings?client_id=sunpharma_paonta_sahib
    // console.log(result);
    const testArray = generateTestColumns(result.data?.tests);
    const headingsArray = generateStaticColumns(result?.data?.headings);
    const editableArray = generateEditableColumns(result?.data?.editable);
    // console.log(testArray, headingsArray, editableArray);
    const tempArray = { ...headingsArray, ...testArray, ...editableArray };
    // console.log(tempArray);
    return tempArray;
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
    return [];
  }
};

export const getHiddenColumnsReviewer = async (data, setData, setLoading) => {
  try {
    setLoading(true);
    const result = await axiosInstance.get(`v1/qc/get_hidden_fields`);
    console.log(result);
    if (result.data) {
      if (result.data.data && setData && typeof setData === "function") {
        const columnsData = result?.data?.data?.reviewer;
        if (columnsData && Object.keys(columnsData).length > 0) {
          const hiddenColumns = columnsData.reduce((acc, columnName) => {
            acc[columnName] = false;
            return acc;
          }, {});
          setData(hiddenColumns);
        } else {
          console.log("Columns data is empty.");
          setData({});
        }
      }
    }
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
  } finally {
    setLoading(false);
  }
};
